import { Conversation, ConversationQuery } from '../models/Conversation'
import { Query } from '../../../common/api/Query'
import { Observable } from 'rxjs'
import { Container } from '../../../common/container/Container'
import { IStatusService } from '../../../common/status/StatusService'
import { IConversationApi } from '../api/ConversationApi'
import { Message } from '../models/Message'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IConversationService {
  getByID(id: string): Observable<Conversation | undefined>

  getFilteredItems(q: Query<ConversationQuery>): Observable<Conversation[]>

  add(e: Conversation): Observable<Conversation | undefined>

  update(e: Conversation): Observable<Conversation | undefined>

  delete(id: string): Observable<boolean>
}

export class ConversationService implements IConversationService {
  protected readonly _apiKey: symbol
  protected _container!: Container
  protected _api!: IConversationApi
  protected _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IConversationApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getFilteredItems(q: Query<ConversationQuery>): Observable<Conversation[]> {
    return this._api.getFilteredItems(q).pipe()
  }

  add(e: Conversation): Observable<Conversation | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Conversation | undefined> {
    return this._api.getByID(id)
  }

  update(e: Conversation): Observable<Conversation | undefined> {
    return this._api.update(e)
  }

  addMessage(m: Message): Observable<Message | undefined> {
    return this._api.addMessage(m)
  }
}
